import React, { useEffect, useState, useContext } from 'react'

import LoadingContext from '../../../context/Loading/Loading'

import {
  getBankAccount,
  getAvailableFunds,
  getMyUpcomingOrders,
} from '../../../utilities/api'

import { PageLoadingContainer } from '../../PageLoadingContainer'
import { SettingsWrapper } from '..'
import { WithdrawCards } from './WithdrawCards'
import { Invoices } from './Invoices'

import './withdrawInvoicesWrapper.scss'

export default function WithdrawInvoicesWrapper() {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)

  const [account, setAccount] = useState()

  const [funds, setAvailableFunds] = useState()

  const [fundsOnHold, setFundsOnHold] = useState()

  const [invoices, setInvoices] = useState()

  useEffect(() => {
    showLoading()
    getMyUpcomingOrders()
      .then((res) => {
        setInvoices(res.data)

        getBankAccount()
          .then((res) => {
            setAccount(res.data)

            getAvailableFunds()
              .then((res) => {
                const available = Array.isArray(res.data)
                  ? []
                  : res.data?.available || []
                const onHold = Array.isArray(res.data)
                  ? res.data
                  : res.data?.onHold || []
                const sum = (rows) =>
                  rows.reduce(
                    (total, row) => total + Number(row.payout || 0),
                    0
                  )
                setAvailableFunds(sum(available))
                setFundsOnHold(sum(onHold))
                hideLoading()
              })
              .catch((err) => {
                console.error(err)
                hideLoading()
              })
          })
          .catch((err) => {
            console.error(err)
            hideLoading()
          })
      })
      .catch((err) => {
        hideLoading()
        console.error(err)
      })
  }, [])

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer />
      ) : (
        <>
          <SettingsWrapper>
            <section id="withdraw">
              <div className="settings-heading">
                <h1 className="settings-title">Payouts</h1>
                <h2 className="settings-subtitle">
                  Resale payouts are deposited to your bank after the event.
                </h2>
              </div>
              <WithdrawCards
                account={account}
                funds={funds}
                fundsOnHold={fundsOnHold}
              />
            </section>
          </SettingsWrapper>
          <section id="invoices">
            <div id="invoices-heading-container">
              <div className="settings-heading">
                <h1 className="settings-title">Invoices</h1>
                <h2 className="settings-subtitle">
                  View / download your previous invoices and transactions below.
                </h2>
              </div>
            </div>
            <Invoices invoices={invoices} />
          </section>
        </>
      )}
    </>
  )
}
